_getUserPortalPlaylist